import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import logo from '../media/Balanz_white_logo.svg'
import validate from '../utils/validatePassword'
import routes from '../api/routes'
import { useGlobalContent } from '../context/helpersProvider'
import expiredToken from '../utils/headerAuth'
export const RestorePassword = (props: any) => {
  interface codeInterface {
    code: string
  }
  const params = useParams();
  const code = params.code as string | undefined;
  const history = useNavigate()
  const location = useLocation()
  const emailFromQuery = new URLSearchParams(location.search).get('email')

  interface Data {
    pass?: string;
    email?: string;
  }
  

  const [errors, setErrors] = useState<Data>({
    pass: '',
    email: '',
  });

  const [error, setError] = useState('')
  const [Datos, setDatos] = useState({
    pass: '',
    pass2: '',
    match: true,
    email: '',
  })

  const { setShowLoading, setShowToast } = useGlobalContent()

  useEffect(() => {
    if (!code && props.location.state === undefined) {
      history('/')
    }
  })

  useEffect(() => {
  if (emailFromQuery) {
    setDatos(prev => ({
      ...prev,
      email: emailFromQuery,
    }))
  }
}, [emailFromQuery])

  const send = (e: any) => {
    e.preventDefault()
    setDatos({ ...Datos, match: true })
    if (!Datos.email || !Datos.pass || !Datos.pass2 || Datos.pass !== Datos.pass2) {
      setDatos({ ...Datos, match: false })
      return
    } else if (!errors.pass) {
      if (code) {
        setShowLoading('true')
        axios
          .put(routes.apiRecoverPass, {
            email: Datos.email,
            code,
            password: Datos.pass,
            rol: 1,
          })
          .then((json) => json.data)
          .then((datos) => {
            setShowLoading('false')
            if (datos.data) {
              setShowToast({ open: 'true', type: 'success', message: datos.message })
              history('/successful_account')
            } else {
              setShowToast({ open: 'true', type: 'error', message: datos.message })
              setError(datos.message)
            }
          })
          .catch((err) => {
            setShowLoading('false')
            expiredToken(history, err, setShowToast)
            setShowToast({ open: 'true', type: 'error', message: 'Something went wrong, please try again' })
          })
      } else {
        setShowLoading('true')
        axios
          .put(routes.apiRecoverPassWithoutCode, {
            email: props.location.state.email,
            prev_password: props.location.state.password,
            password: Datos.pass,
          })
          .then((json) => json.data)
          .then((datos) => {
            setShowLoading('false')
            if (datos.data) {
              setShowToast({ open: 'true', type: 'success', message: datos.message })
              history('starting')
            } else {
              setShowToast({ open: 'true', type: 'error', message: datos.message })
              setError(datos.message)
            }
          })
          .catch((err) => {
            setShowLoading('false')
            expiredToken(history, err, setShowToast)
            setShowToast({ open: 'true', type: 'error', message: 'Something went wrong, please try again' })
          })
      }
    }
  }

  const handleErrors = (e: any) => {
    const { name, value } = e.target as { name: keyof Data; value: string };
    if (name === 'pass' || name === 'email') {
      // Validar solo los campos que correspondan al frontend
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: validate({ [name]: value })[name], // Asume que validate devuelve un objeto con errores
      }));
    }
  }


  const handleChange = (e: any) => {
    const { name, value } = e.target
    setDatos({ ...Datos, [name]: value })
  }

  return (
    <div className='columns w-row container-log'>
      <div className='logocolumn w-col w-col-4 w-col-stack'>
        <img src={logo} loading='lazy' alt='Balanz logo' width='600' className='loginlogo' />
      </div>
      <div className='formcolumn w-col w-col-8 w-col-stack'>
        <div className='form w-form'>
          <form id='wf-form-new-pass' name='wf-form-new-pass' data-name='new-pass' method='get'>
            <h3 className='h2-titles'>New password</h3>
            <p className='paragraph' style={{ textAlign: 'justify' }}>
              You have been cleared to access the Balanz research website and you will be able to login with your corporate e-mail and desired password. Please set your password in the field below.
            </p>
            <label htmlFor="email" className="field-label">
              Your Corporate E-mail
            </label>
            <input
              type="mail"
              autoFocus={true}
              className="text-field email w-input"
              placeholder="Corporate E-mail"
              name="email"
              value={Datos.email}
              onChange={handleChange}
              onBlur={handleErrors}
            />
            {errors.email && <p className='alert'>{errors.email}</p>}

            <label htmlFor='new-pass' className='field-label'>
              Password
            </label>
            <input
              type='password'
              className='text-field pass w-input'
              maxLength={256}
              name='pass'
              placeholder='New password'
              onChange={handleChange}
              onBlur={handleErrors}
              value={Datos.pass}
              autoComplete="off"
            />
            {errors.pass && <p className='alert'>{errors.pass}</p>}
            <label htmlFor='confirm-pass' className='field-label'>
              Confirm password
            </label>
            <input
              type='password'
              className='text-field pass w-input'
              maxLength={256}
              name='pass2'
              placeholder='Confirm your password'
              onChange={handleChange}
              value={Datos.pass2}
              autoComplete="off"
            />
            {!Datos.match ? <span className='alert'>Both fields must match</span> : null}
            <p className='alert'>{error}</p>
            <input
              type='submit'
              data-wait=''
              value='Continue'
              className='button continue w-button'
              onClick={send}
            />
          </form>
        </div>
      </div>
    </div>
  )
}
